<template>

    <div class="outer-wrapper">

        <div class="profile-pedigree" v-if=" hasProfileInfo && profileInfo.user.name != null ">

            <div>

                <p class="profile-name">{{ profileInfo.user.name }}</p>
                <p class="phone-number">{{ formattedNumber }}</p>
            </div>
        </div>

        <div class="card-wrap" v-if=" hasProfileInfo && profileInfo.prepaidAccount ">

            <div class="profile-account-wrapper">

                <div class="account-details-wrapper">

                    <h3>Rewards Account</h3>
                    <p :class=" profileInfo.prepaidAccount.prepaidAccountStatus == 1 ? 'profile-active' : 'profile-inactive' "></p>
                </div>

                <p :class=" pointsClasses ">{{ profilePoints }}</p>
            </div>
        </div>

        <div class="card-wrap" v-if=" hasProfileInfo ">

            <div class="profile-details-top-wrapper">

                <h3>Your Profile</h3>
                <p class="edit-profile" @click=" toggleEdit() " v-if=" formDisabled  ">Edit Profile</p>
                <div v-else class="save-cancel-block">

                    <p class="cancel-edit"  @click=" toggleEdit() ">Cancel</p>
                    <p class="save-profile" @click=" saveForm()   ">Save</p>
                </div>
            </div>
            <div class="birthday-wrap" >

                <div>

                    <p class="input-title">Help us celebrate your birthday!</p>
                    <p>receive gifts and specials on a day all about you!</p>
                </div>
                <div class="date-format-wrapper" @click=" initEdit ">

                    <input type="date" v-model=" profileInfo.expressContact.birthDate " class="input-data" :disabled=" formDisabled ">
                    <font-awesome-icon class="calendar-icon" icon="calendar-alt" />
                </div>
            </div>

            <transition name="slide-down">

                <div class="profile-info-wrapper" v-if=" !formDisabled ">

                    <h3 style="margin: 0">Basic Information</h3>
                    <div class="input-wrap" >

                        <p class="input-title">name:</p>
                        <input type="text" v-model=" profileInfo.user.name " class="input-data" :disabled=" formDisabled ">
                    </div>
                    <!-- <div class="input-wrap" >

                        <p class="input-title">phone:</p>
                        <input type="number" v-model=" profileInfo.user.phone " class="input-data" :disabled=" formDisabled ">
                    </div> -->
                    <div class="input-wrap" >

                        <p class="input-title">email:</p>
                        <input type="text" v-model=" profileInfo.user.email " class="input-data" :disabled=" formDisabled ">
                    </div>

                    <div class="input-outer-wrapper">

                        <div class="input-wrap" >

                            <p class="input-title">gender:</p>
                            <select v-model=" profileInfo.expressContact.gender " class="input-data" :disabled=" formDisabled ">

                                <option value="m">male</option>
                                <option value="f">female</option>
                            </select>
                        </div>
                        <div class="input-wrap" >

                            <p class="input-title">state:</p>
                            <select v-model=" profileInfo.user.state " class="input-data" :disabled=" formDisabled ">

                                <option v-for=" ( state, stateKey ) in unitedStates " :key=" stateKey " :value=" stateKey ">{{ state }}</option>
                            </select>
                        </div>

                    </div>

                    <div class="input-outer-wrapper">

                        <div class="input-wrap" >

                            <p class="input-title">zip:</p>
                            <input type="number" v-model=" profileInfo.user.zip " class="input-data" :disabled=" formDisabled ">
                        </div>
                        <div class="input-wrap" >

                            <p class="input-title">city:</p>
                            <input type="text" v-model=" profileInfo.user.city " class="input-data" :disabled=" formDisabled ">
                        </div>
                    </div>
                    <div class="input-wrap" >

                        <p class="input-title">address:</p>
                        <input type="text" v-model=" profileInfo.user.address " class="input-data" :disabled=" formDisabled ">
                    </div>
                    <div class="input-wrap" >

                        <p class="input-title">address2:</p>
                        <input type="text" v-model=" profileInfo.user.address2 " class="input-data" :disabled=" formDisabled ">
                    </div>
                </div>
            </transition>

            <p class="update-error" v-if=" profileUpdateError != null ">{{ profileUpdateError }}</p>

            <div v-if=" !formDisabled " class="save-button-wrapper">

                <button @click=" saveForm() " type="button" class="button btn-green save-button">Save Updates</button>
            </div>
        </div>
    </div>
</template>

<script>

    import { mapGetters } from 'vuex';
    import FontAwesomeIcon from '@fortawesome/vue-fontawesome';

    export default {

        name: 'profile',
        data : function(){

            return{

                formDisabled : true
            }
        },
        computed: {

            ...mapGetters({

                activeRole         : 'auth/activeRole',
                profileInfo        : 'auth/profileInfo',
                unitedStates       : 'unitedStates',
                profileUpdateError : 'auth/profileUpdateError',
                tabOpen            : 'orderTab/tabOpen'
            }),
            formattedNumber(){

                return '( ' + this.profileInfo.user.phone.substring( 0, 3 ) + ' ) ' + this.profileInfo.user.phone.substring( 3, 6 ) + ' - ' + this.profileInfo.user.phone.substring( 6, 10 );
            },
            pointsClasses(){

                const base = [ 'account-points' ];
                base.push( ( this.profileInfo.prepaidAccount.prepaidAccountBalance == null || this.profileInfo.prepaidAccount.prepaidAccountBalance < 1 ) ? 'no-points' : 'has-points' );
                return base.join( ' ' );
            },
            profilePoints(){

                if( this.profileInfo.prepaidAccount.prepaidAccountBalance == null || this.profileInfo.prepaidAccount.prepaidAccountBalance < 1 ){

                    return 'Seems like you haven\'t gotten points yet!';
                }
                return this.profileInfo.prepaidAccount.prepaidAccountBalance + ' pts';
            },
            hasProfileInfo(){

                return Object.values( this.profileInfo ).length > 0;
            }
        },
        methods: {

            toggleEdit(){

                this.formDisabled = !this.formDisabled;
            },
            saveForm(){

                this.$store.dispatch( 'auth/saveProfileInfo' );
                this.formDisabled = !this.formDisabled;
            },
            logout(){

                this.$store.dispatch( 'auth/signout' );
            },
            initEdit(){

                if( this.formDisabled ) this.toggleEdit();
            }
        },
        created(){


            this.$store.dispatch( 'auth/initApp' );
        },
        components: {

            FontAwesomeIcon
        }
    }

</script>

<style scoped>


  .slide-down-enter-active {

    animation: slide-in .25s ease;
  }

  .slide-down-leave-active {

    animation: slide-out .25s ease;
  }

  @keyframes slide-in {

    from {

        transform: translateY( 100% );
    }
    to {

      transform: translateY( 0% );
    }
  }

  @keyframes slide-out {

    from {

        transform: translateY( 0px );
    }
    to {

      transform: translateY( 100% );
    }
  }

    .profile-pedigree {

        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-left: 10px;
        margin-top: 20px;
        margin-bottom: 50px;
    }
    .profile-name {

        font-size: 30px;
        font-weight: bold;
    }
    .phone-number {

        font-size: 18px;
        padding-left: 5px;
        color: #777;
    }

    .profile-account-wrapper {

        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }
    .account-details-wrapper {

        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .profile-active {

        width: 30px;
        height: 30px;
        border-radius: 50%;
        margin-right: 5px;
        background-color: rgba(42, 189, 42, 0.75);
    }
    .profile-inactive {

        width: 30px;
        height: 30px;
        border-radius: 50%;
        margin-right: 5px;
        background-color: rgba(206, 20, 20, 0.75);
    }
    .account-points {

        font-size: 24px;
    }
    .has-points {

        font-weight: bold;
        font-size: 20px;
        color: #333;
    }
    .no-points {

        font-weight: bold;
        font-size: 16px;
        color: rgb(58, 148, 98);
    }


    .profile-details-top-wrapper {

        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .edit-profile {

        color: rgb( 21, 66, 198 );
    }
    .save-profile {

        color: green;
    }
    .cancel-edit {

        color: rgb( 173, 8, 8 );
    }
    .save-cancel-block {

        display: flex;
        width: 110px;
        justify-content: space-between;
    }

    .birthday-wrap {

        display: flex;
        flex-direction: column;
        justify-content: space-around;
        height: 200px;
    }
    .calendar-icon {

        font-size: 35px;
        margin-left: 10px;
    }
    .date-format-wrapper {

        display: flex;
        align-items: center;
        height: 40px;
    }
    .date-format-wrapper > input {

        text-align: right;
        font-size: 20px;
    }
    .profile-info-wrapper {

        display: flex;
        flex-direction: column;
        justify-content: space-around;
        padding-top: 25px;
    }
    .input-wrap {

        padding: 15px 0px;
    }
    .input-title {

        color: blue;
        font-weight: 600;
        font-size: 1.1rem;
        margin: 0;
    }
    .input-data {

        box-sizing: border-box;
        margin: 4px 0;
        padding-left: 14px;
        border: none;
        border-bottom: 2px solid #ccc;
        width: 100%;
        font-size: 1.2rem;
        background-color: transparent;
    }
    .input-data:focus,
    .input-data:active {

        outline: none;
        border-bottom: 2px solid #9bbcff;
    }
    .input-data:disabled {

        background-color: transparent;
    }

    .input-outer-wrapper {

        display: flex;
    }
    .input-outer-wrapper > .input-wrap {

        flex: 1;
        max-width: 50%;
    }
    .input-outer-wrapper > .input-wrap:nth-child( 2 ) {

        margin-left: 5px;
    }

    .save-button-wrapper {

        display: flex;
        align-items: center;
        justify-content: center;
        height: 85px;
    }
    .update-error {

        color: red;
        font-weight: bold;
        text-align: center;
    }
</style>